import React, {useEffect, useState} from 'react';
import {HTML_CONTENT_TYPE_LIST} from "../../constants/content.constant";
import _ from "lodash";

const SelectHtmlTag = ({
                           showKey = false,
                           contentLine,
                           contentLineIndex,
                           changeContentLineType = undefined,
                           elementTypeList = HTML_CONTENT_TYPE_LIST
                       }) => {
    const [selectedTag, setSelectedTag] = useState(contentLine.newType || contentLine.type);

    const handleTagSelection = (contentTypeKey) => {
        setSelectedTag(contentTypeKey);

        if (changeContentLineType) {
            changeContentLineType(contentLineIndex, contentTypeKey);
        }
    }

    return (
        <>
            <div className="flex flex-wrap mt-1">
                {contentLine.key &&
                    <div className="button-gray-outline px-2 m-1">
                        <span className={'text-sm'}>{contentLine.key}</span>
                    </div>
                }

                {elementTypeList?.map((contentType, index) => (
                    <div key={index}>
                        <button
                            className={`px-2 m-1 ${selectedTag === contentType.key ? 'button-green' : 'button-outline-green'}`}
                            onClick={() => handleTagSelection(contentType.key)}>
                            {showKey &&
                                <span className={'text-sm'}>{_.toUpper(contentType.key)}</span>
                            }
                            {!showKey &&
                                <span className={'text-sm'}>{_.toUpper(contentType?.shortLabel)}</span>
                            }
                        </button>
                    </div>
                ))}
            </div>
        </>
    )
}

export default SelectHtmlTag
